export const taskDateTypeConstant = [
    { name: "Assigned", value: "assigned" },
    { name: "Actual", value: "actual" },
  ];
  